import dictionaries, { DictionariesType } from '../../branding/common/dictionaries';
import general from '../../branding/common/dictionaries/general.json';
import { BankType, BrandType, Country } from '../../generated/graphql';
import { memoize } from '../../utils/memoize';

const baseDictionary = { ...general };

const getDictionaryFunction = (
  country?: Country,
  brand?: BrandType,
  bank?: BankType,
) => {
  let newAllDict: typeof baseDictionary = { ...baseDictionary };
  /* Make the keys to search the specific dictionary,
    removing bank and then country if they dont exist */
  const searchCombinations = [ brand, country, bank ].filter((item) => !!item)
    .reduce((keys, current) => {
      const lastKey = keys?.[keys.length - 1] || '';
      const newKey: string | undefined = !lastKey ? current || '' : `${lastKey}-${current}`;
      return [ ...keys, newKey ];
    }, [ '' ] as string[]).reverse();

  let selectedDictionary: DictionariesType | undefined;
  searchCombinations.forEach((nameToSearch) => {
    if (!selectedDictionary) {
      selectedDictionary = dictionaries.find(({ name }) => name === nameToSearch);
    }
  });

  if (selectedDictionary) {
    selectedDictionary.dictionaries.forEach((dictionary) => {
      newAllDict = { ...newAllDict, ...dictionary };
    });
  }

  return newAllDict as
    typeof baseDictionary & { [key: string]: string };
};

export const getDictionary = memoize(getDictionaryFunction);
